import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import cn from "classnames";
import s from "./Icon.module.scss";

export interface IconProps {
  direction: "bottom" | "right";
}

export default function Icon(props: IconProps) {
  const { direction } = props;

  const className = cn({
    [s.bottom]: direction === "bottom",
    [s.right]: direction === "right",
  });

  return <ArrowDropDownIcon className={className} />;
}
